import Model from './Model'
export default class Employee extends Model {

    resource()
    {
        return 'employees'
    }

    get rolesList() {
        return (this?.roles || []).map(role => role.display_name).join(', ')
    }

    get isActive()
    {
        return this.is_active ? 'Activ' : 'Inactiv';
    }

    /*get active()
    {
        return this.isActive
    }

    set active(val) {
        this.is_active = val
    }*/
}
